module.exports = __webpack_public_path__ + "static/img/diyimmove1.5704522.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rppghealth/diyimmove1.png
// module id = oD9Z
// module chunks = 5